import { useAppConfigContext } from '@/context/AppConfig';
import { CookiesStorage } from '@/storage/index';
import { Text } from '@/theme/index';
import { useRedirect } from '@/utils/hooks/useRedirect';
import { QuestionsSurvey } from './QuestionsSurvey';
import { ContentContainer } from './components';
import { OnboardingQuestionSet, useOnboardingQuestions } from '../index';

export function DynamicQuestionsService() {
  const { redirect } = useRedirect();

  const { error, data } = useOnboardingQuestions();

  if (error) {
    const cookiesStorage = new CookiesStorage();
    const first_report_navigate = cookiesStorage.getValue(
      'first_report_navigate'
    );
    if (first_report_navigate) {
      cookiesStorage.removeValue('first_report_navigate');
      redirect(first_report_navigate);
    } else {
      const { routingUtils } = useAppConfigContext();
      const { location } = routingUtils;
      const locationState = location.state as { next?: string };

      redirect(locationState?.next || '/dashboard');
    }
  }

  if (data && (data as OnboardingQuestionSet).question_set) {
    const onboardingData = data as OnboardingQuestionSet;
    return <QuestionsSurvey questionsSet={onboardingData.question_set} />;
  }

  return (
    <ContentContainer>
      <Text variant="h1" color="primary" textAlign="center">
        Loading Questions
      </Text>
    </ContentContainer>
  );
}
